<script setup lang="ts">
</script>
<template>
  <div class="flex items-center justify-between w-full">
    <div class="flex items-center gap-2">
      <slot name="left" />
    </div>
    <div class="flex items-center gap-2">
      <slot name="right" />
    </div>
  </div>
</template>
